import {
  type IconName,
  NonIdealState,
  NonIdealStateIconSize,
} from "@blueprintjs/core";
import { useSelectorWall } from "@package/ui-redux";

function WallErrorNonIdealState({
  description,
  icon,
  title,
}: {
  description: string;
  icon: IconName;
  title: string;
}) {
  return (
    <NonIdealState
      className="text-5xl text-gray-100"
      description={description}
      icon={icon}
      iconSize={NonIdealStateIconSize.STANDARD}
      layout="vertical"
      title={title}
    />
  );
}

export function WallErrorContent() {
  const initialization = useSelectorWall((state) => state.wall.initalization);

  if (initialization === "activation-required") {
    return (
      <WallErrorNonIdealState
        description="This device requires activiation. Please content the PanoScape account manager to assist with Activation"
        icon="cloud-tick"
        title="Device Activation Required"
      />
    );
  }

  if (initialization === "denied") {
    return (
      <WallErrorNonIdealState
        description="This device has been disabled. Please content the PanoScape account manager to assist with Activation"
        icon="warning-sign"
        title="Device Denied"
      />
    );
  }

  if (initialization === "failure") {
    return (
      <WallErrorNonIdealState
        description="The system failed to start. Please content the PanoScape account manager for assistance."
        icon="error"
        title="System Error"
      />
    );
  }

  return null;
}

export function WallError() {
  return (
    <div className="flex h-full w-full items-center justify-center text-white">
      <WallErrorContent />
    </div>
  );
}
